import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import useParams from "../../Hooks/useParams";
import FAIcon from "../../UI/FAIcon/FAIcon";
import { getMessageInboxPath, getMessageSchedulePath, getMessageSentPath, getMessageTemplatePath, } from "./MessageRoutes/MessageRoutes";
const MessageNewView = (props) => {
    const params = useParams();
    const history = useHistory();
    const location = useLocation();
    const onCancel = () => {
        props.setIsMobileFullScreen(false);
        if (location === null || location === void 0 ? void 0 : location.pathname.includes("inbox")) {
            history.push(getMessageInboxPath());
        }
        else if (location === null || location === void 0 ? void 0 : location.pathname.includes("schedules")) {
            history.push(getMessageSchedulePath());
        }
        else if (location === null || location === void 0 ? void 0 : location.pathname.includes("templates")) {
            history.push(getMessageTemplatePath());
        }
        else {
            history.push(getMessageSentPath());
        }
    };
    return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex align-items-center flex-row-reverse justify-content-between flex-grow-1", children: _jsx("button", { type: "button", className: "d-block d-md-none btn btn-link text-dark", onClick: onCancel, title: "Exit Fullscreen", children: _jsx(FAIcon, { icon: "times", srText: "Exit Fullscreen" }) }) }), children: _jsx("div", { className: "container-fluid pt-3 bg-light pb-5 fullMinHeightMinusSecondaryNav", children: _jsxs("div", { children: [params.messageSent && (_jsx("div", { className: "text-center alert alert-light w-100 h5", children: _jsxs("span", { children: [_jsx(FAIcon, { icon: "check", type: "fal", size: "lg", className: "text-success" }), " ", "Your message was successfully sent"] }) })), !params.messageSent && (_jsx("div", { className: "text-center pt-2 w-100", children: _jsxs("span", { children: [props.isTemplate
                                    ? "Please select a Template"
                                    : "Please select a message", _jsx(FAIcon, { icon: props.isTemplate ? "folders" : "envelope", type: "fal", className: "ml-1", size: "sm" })] }) }))] }) }) }));
};
export default MessageNewView;
